/**
 * @Author: Zero
 * @Date: 2024-10-21 23:34:40
 * @Explain: 级联选择器 - 选项列表
 */

import { intlGet } from '@/locales';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
// type
import { CascaderOptionListProps } from '../data.d';
// components
import { SearchBox } from '@/components/tdesign';
import CascaderGroupList from './cascaderGroupList';
import CascaderList from './cascaderList';
import FilterList from './filterList';
// utils
import {
  cascaderDoesItExist,
  isArrayLen,
  isString,
} from '@/utils/common/dataJudgment';
import { defaultListMaxHeight, treeAddParentId } from '../const';

type PropsType = {
  /** 列表宽度 */
  listWidth?: number | string;
} & CascaderOptionListProps;
const CascaderOptionList = (props: PropsType) => {
  let {
    searchable,
    searchPlaceholder,
    allOption,
    multiple,
    options,
    value,
    displayTextKey,
    emptyText = intlGet('COMMON.NO.DATA'),
    className,
    valueMode,
    valueType = 'full',
    showAllLevels = false,
    listWidth,
    isGroup,
    groupKey,
    listMaxHeight = defaultListMaxHeight,
    listHeader,
    onScroll,
    onClose,
    onClick,
    onChange,
  } = props;
  if (isString(value)) {
    value = [];
  }
  const [searchValue, setSearchValue] = useState<any>();
  // 列表
  const list: any[] = useMemo(() => {
    let newList = searchValue
      ? cascaderDoesItExist({ list: options, searchValue })
      : allOption
      ? [{ label: intlGet('COMMON.ALL'), value: 'all' }, ...options]
      : options;
    return treeAddParentId(newList);
  }, [options, searchValue, allOption]);
  return (
    <>
      {/* 搜索框 */}
      {searchable && (
        <div className="dropdown-search-box">
          <SearchBox
            autofocus
            size="full"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={setSearchValue}
          />
        </div>
      )}
      {/* 列表 */}
      {isArrayLen(list) ? (
        searchValue ? (
          <FilterList
            value={value}
            options={list}
            multiple={multiple}
            emptyText={emptyText}
            listWidth={listWidth}
            listMaxHeight={listMaxHeight}
            displayTextKey={displayTextKey}
            onChange={onChange}
          />
        ) : isGroup ? (
          <CascaderGroupList
            value={value}
            options={list}
            multiple={multiple}
            groupKey={groupKey}
            listHeader={listHeader}
            // valueMode={valueMode}
            valueType={valueType}
            showAllLevels={showAllLevels}
            listWidth={listWidth}
            listMaxHeight={listMaxHeight}
            displayTextKey={displayTextKey}
            onChange={(val, context) => onChange?.(val, context)}
            className={classNames(
              'default-cascader-panel default-group-cascader-panel',
              className,
            )}
          />
        ) : (
          <CascaderList
            value={value}
            options={list}
            multiple={multiple}
            listHeader={listHeader}
            // valueMode={valueMode}
            valueType={valueType}
            showAllLevels={showAllLevels}
            listWidth={listWidth}
            listMaxHeight={listMaxHeight}
            displayTextKey={displayTextKey}
            onChange={(val, context) => onChange?.(val, context)}
            className={classNames('default-cascader-panel', className)}
          />
        )
      ) : (
        // 暂无数据
        <div className="pd-10 text-align-center">{emptyText}</div>
      )}
    </>
  );
};

export default CascaderOptionList;
